/* eslint-disable react/jsx-no-duplicate-props */
import React, { ChangeEvent } from 'react'
import { InputAdornment } from '@mui/material'
import { merge } from 'lodash'
import TextField, { TextFieldProps } from './TextField'
import { applyMask } from '../../services/utils'

const CURRENCY_MAX_LENGTH = 14

export type MoneyFieldProps = {
	isFullCurrency?: boolean
} & TextFieldProps

const MoneyField = ({
	InputProps,
	isFullCurrency = false,
	...rest
}: MoneyFieldProps) => {
	const startAdornment = (
		<InputAdornment position="start">$</InputAdornment>
	)
	const mergedInputProps = InputProps
		? merge(InputProps, { startAdornment })
		: { startAdornment }

	const onChange = (event: ChangeEvent<{ value: string }>) => {
		// eslint-disable-next-line no-param-reassign
		event.target.value = applyMask(
			event.target.value,
			isFullCurrency ? 'fullCurrency' : 'currency'
		) // @todo this should be handled with state and not set on the event
	}

	return (
		<TextField
			onChange={onChange}
			{...rest}
			InputProps={mergedInputProps}
			inputProps={{
				maxLength: CURRENCY_MAX_LENGTH,
				...rest.inputProps,
			}}
		/>
	)
}

export default MoneyField
